/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "parts/Header";
import Footer from "parts/Footer";
import { fetchAllBlogs } from "../utils/blogLoader.js";
import "./BlogPage.css";
import Discuss from "../parts/Discuss.js";

export default class BlogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      searchQuery: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    fetchAllBlogs().then((blogs) => {
      this.setState({ blogs });
    });
  }

  render() {
    const { blogs, searchQuery } = this.state;

    if (!blogs || blogs.length === 0) {
      return (
        <>
          <Header />
          <div className="blog-loading">
            <div className="loading-inner">
              <span className="loading-dot" />
              <span className="loading-dot" />
              <span className="loading-dot" />
            </div>
          </div>
          <Footer />
        </>
      );
    }

    const featured = blogs[0];
    const latestThree = blogs.slice(0, 3);
    const gridBlogs = blogs.slice(3);

    return (
      <>
        <Header />

        {/* ── HERO ── */}
        <section className="bp-hero">
          <div className="bp-hero__noise" aria-hidden="true" />
          <div className="bp-hero__grid-lines" aria-hidden="true" />

          <div className="bp-hero__inner">
            {/* left: meta + headline */}
            <div className="bp-hero__copy">
              <div className="bp-hero__eyebrow">
                <span className="bp-tag bp-tag--light">Featured</span>
                <span className="bp-hero__date">{featured.date}</span>
              </div>

              <h1 className="bp-hero__title">{featured.title}</h1>

              <p className="bp-hero__desc">{featured.description}</p>

              <div className="bp-hero__actions">
                <Link to={`/guvrnspeak/${featured.slug}`} className="bp-btn bp-btn--primary">
                  Read article
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Link>
                <span className="bp-hero__read-time">5 min read</span>
              </div>
            </div>

            {/* right: image */}
            {featured.image && (
              <div className="bp-hero__media">
                <div className="bp-hero__media-frame">
                  <img src={featured.image} alt={featured.title} />
                  <div className="bp-hero__media-caption">
                    <span>{featured.title}</span>
                  </div>
                </div>
                <div className="bp-hero__media-accent" aria-hidden="true" />
              </div>
            )}
          </div>

          {/* floating scroll cue */}
          <div className="bp-hero__scroll-cue" aria-hidden="true">
            <span>Scroll</span>
            <div className="bp-hero__scroll-line" />
          </div>
        </section>

        {/* ── LATEST + SEARCH ── */}
        <section className="bp-latest">
          <div className="bp-container">
            <div className="bp-latest__header">
              <div className="bp-latest__heading-wrap">
                <p className="bp-section-label">Latest stories</p>
                <h2 className="bp-section-title">guvrnspeak</h2>
              </div>

              <div className="bp-search">
                <svg className="bp-search__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
                <input
                  type="text"
                  placeholder="Search articles…"
                  className="bp-search__input"
                  value={searchQuery}
                  onChange={(e) => this.setState({ searchQuery: e.target.value })}
                />
              </div>
            </div>

            {/* primary card + stacked side cards */}
            {latestThree.length > 0 && (
              <div className="bp-grid">
                {latestThree.map((blog) => (
                  <Link
                    key={blog.slug}
                    to={`/guvrnspeak/${blog.slug}`}
                    className="bp-card"
                  >
                    {blog.image && (
                      <div className="bp-card__img-wrap">
                        <img src={blog.image} alt={blog.title} />
                        <div className="bp-card__img-overlay" />
                      </div>
                    )}

                    <div className="bp-card__body">
                      <span className="bp-tag bp-tag--dark">Article</span>
                      <h3 className="bp-card__title">{blog.title}</h3>
                      <p className="bp-card__date">{blog.date}</p>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* ── BLOG GRID ── */}
        {gridBlogs.length > 0 && (
          <section className="bp-grid-section">
            <div className="bp-container">
              <div className="bp-grid">
                {gridBlogs.map((blog, i) => (
                  <Link
                    key={blog.slug}
                    to={`/guvrnspeak/${blog.slug}`}
                    className={`bp-card bp-card--grid ${i === 0 ? "bp-card--grid-wide" : ""}`}
                  >
                    {blog.image && (
                      <div className="bp-card__img-wrap">
                        <img src={blog.image} alt={blog.title} />
                        <div className="bp-card__img-overlay" />
                      </div>
                    )}
                    <div className="bp-card__body">
                      <div className="bp-card__meta">
                        <span className="bp-tag bp-tag--outline">Article</span>
                        <span className="bp-card__date">{blog.date}</span>
                      </div>
                      <h3 className="bp-card__title">{blog.title}</h3>
                      <span className="bp-card__arrow">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M4 9h10M10 5l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* ── CONTACT FORM SECTION ── */}
        <section className="bp-contact">

      {/* 👇 Your full contact form */}
      <Discuss />

        </section>

        <Footer />
      </>
    );
  }
}
